import {styled} from "@mui/material/styles";
import {MouseEventHandler, useCallback} from "react";

import ExpandCollapse from "./ExpandCollapse";

interface IFluxExpandCollapse {
    previewHeight: number; // pixels
    children: React.ReactNode;
    backgroundColor?: string;
}

// Same rules as the main app's FluxExpandCollapse.css, expressed via emotion so
// they survive both the standalone and federation builds.
const ExpandCollapseRoot = styled("div")(({theme}) => ({
    "& .react-expand-collapse__content": {
        position: "relative",
        overflow: "hidden",
    },
    "& .react-expand-collapse__body": {
        display: "inline-block",
        maxWidth: "calc(100% - 50px)",
        overflowWrap: "break-word",
    },
    "& .react-expand-collapse__button": {
        color: theme.palette.text.secondary,
        position: "absolute",
        bottom: 0,
        right: 0,
        cursor: "pointer",
        WebkitTapHighlightColor: "transparent",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    "& .react-expand-collapse--expanded .react-expand-collapse__button": {
        paddingLeft: "5px",
        position: "relative",
        bottom: "auto",
        right: "auto",
        "&:before": {
            content: "none",
        },
    },
    "& .react-expand-collapse--expanded .react-expand-collapse__body": {
        maxWidth: "100%",
    },
}));

/**
 * Mirror of the main app's FluxExpandCollapse wrapper. Note the underlying
 * component clamps by height, not lines.
 */
export function FluxExpandCollapse(props: IFluxExpandCollapse) {
    // NOTE: Added to prevent the click from opening a template.
    const blockAnythingBehind: MouseEventHandler = useCallback((e) => e.stopPropagation(), []);

    return (
        <ExpandCollapseRoot>
            <ExpandCollapse
                previewHeight={props.previewHeight + "px"}
                expandText={"show more"}
                collapseText={"show less"}
                backgroundColor={props.backgroundColor}
                onClick={blockAnythingBehind}
            >
                {props.children}
            </ExpandCollapse>
        </ExpandCollapseRoot>
    );
}
